<template>
    <sg-phone class="mt-3" :new-user="false" form-message="Введите номер телефона и выберите пароль"
        :form-show-cancel="isAndroid" form-show-features @done="onDone" @cancel="onCancel" />
</template>

<script>
    import pageMixin from './pageMixin'
    import SgPhone from '@/components/phone/SgPhone'

    export default {
        name: 'sg-wire-phone',

        props: {
            onlyPhone: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        mixins: [pageMixin],

        components: {
            SgPhone
        },

        methods: {

            onCancel() {
                this.cancel()
            },

            onDone() {
                if (this.onlyPhone) {
                    this.phoneOk()
                } else {
                    this.wireServices()

                }
            },
            wireServices() {

                this.$store.dispatch('settings/FETCH')
                    .then(res => {
                        this.$router.push({
                            name: 'wv-wireservices',
                            params: {
                                newUser: false
                            }
                        })
                    })
            },
        },
    }
</script>

<style>

</style>